// store/authStore.js
import { create } from "zustand";
import { getBannerData } from "../api/home";
import { getConcreteData } from "../api/concrete";

export const useConcreteStore = create((set, get) => ({
    loading: true,
    banner: null,
    concrete: [],

    getBanner: async () => {
        try {
            set({ loading: true })
            const res = await getBannerData('concrete')
            set({ loading: false, banner: res })
            return res
        } catch (error) {
            console.log("Error in checkAuth:", error);
            set({ authUser: null, hasTriedAuth: true });
            return false;
        } finally {
            set({ isCheckingAuth: false, hasTriedAuth: true });
        }
    },
    getConcrete: async (pageNumber, pageSize, search, field) => {
        try {
            set({ loading: true })
            const res = await getConcreteData(pageNumber, pageSize, search, field)
            set({ loading: false, concrete: res?.ref })
            return res
        } catch (error) {
            console.log("Error in checkAuth:", error);
            set({ authUser: null, hasTriedAuth: true });
            return false;
        } finally {
            set({ isCheckingAuth: false, hasTriedAuth: true });
        }
    }

}));
